/**
 * bootstrapGuard — module-level singleton that tracks whether the app
 * has completed its first full bootstrap (auth + initial data load).
 *
 * Once marked, stays true for the lifetime of the browser session.
 * Used to prevent the full-screen loader from appearing on subsequent
 * route navigations after the user is already inside the app.
 */
let _bootstrapped = false;

export const hasBootstrapped = () => _bootstrapped;

export const markBootstrapped = () => {
  _bootstrapped = true;
};

export const resetBootstrapped = () => {
  _bootstrapped = false;
};
